<template>
    <div class="notification-row" :class="['col-' + (source ? source.columns : 1)]">
        <NotificationCard
            v-for="(n, idx) in (source ? source.items : [])"
            :key="(n.sensorId || '') + '-' + (n.timestamp || '') + '-' + idx"
            :sensor-id="n.sensorId"
            :alert-index="n.timestamp"
            :count="n.count"
            @select="handleSelect"
        />
    </div>
</template>

<script>
import NotificationCard from '@/components/domain/sensor/NotificationCard.vue'

export default {
    name: 'NotificationRow',
    components: { NotificationCard },
    props: {
        index: {
            type: Number,
            default: 0
        },
        source: {
            type: Object,
            default() {
                return { id: 0, columns: 1, items: [] }
            }
        },
        onSelect: {
            type: Function,
            default: null
        }
    },
    methods: {
        handleSelect(sensorId) {
            if (this.onSelect) this.onSelect(sensorId)
        }
    }
}
</script>

<style lang="scss" scoped>
.notification-row {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    padding-bottom: 16px;

    &.col-5 { grid-template-columns: repeat(5, 1fr); }
    &.col-4 { grid-template-columns: repeat(4, 1fr); }
    &.col-3 { grid-template-columns: repeat(3, 1fr); }
    &.col-2 { grid-template-columns: repeat(2, 1fr); }
    &.col-1 { grid-template-columns: 1fr; }
}
</style>


